import { PREMIUM_STAR_ICON } from 'constants/Images';
import usePremium from 'hooks/usePremium';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import styles from './styles.module.css';

// Khối trạng thái gói trong dropdown profile, chỉ hiện với khách đang có gói.
const PremiumMembershipBlock = () => {
  const { hasActiveMembership, membershipName, membershipShortName, expiredAtText, remainingDays } = usePremium();

  if (!hasActiveMembership) return null;

  return (
    <div className={styles.premiumBlock} data-test="profile-premium-block">
      <span className={styles.premiumBadge}>
        <ImageFallbackStatic src={PREMIUM_STAR_ICON} width="14" height="14" alt="Premium" objectFit="contain" />
        <span className={styles.premiumBadgeText}>{membershipShortName}</span>
      </span>
      <p className={styles.premiumTitle}>
        {'Gói '}
        <span className={styles.premiumProgramName}>{membershipName}</span>
        {' đang hoạt động'}
      </p>
      {expiredAtText ? (
        <p className={styles.premiumExpiry}>{`Hiệu lực đến ${expiredAtText} · Còn ${remainingDays} ngày`}</p>
      ) : null}
    </div>
  );
};

export default PremiumMembershipBlock;
